<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->


          <hr>

          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('myuser.title')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">

                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="id" class=" form-control-label">{{$t('myuser.id')}}</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<p class="form-control-static"><input v-model="data.id" type="text" id="id" name="text-input" placeholder="" class="form-control" disabled readonly></p>-->
                  <!--</div>-->
                  <!--</div>-->

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="firstName" class=" form-control-label">{{ $t('myuser.firstName') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.firstName" type="text" id="firstName" placeholder="" class="form-control" name="data.firstName"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.firstName')}"
                             readonly disabled
                      >
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="lastName" class=" form-control-label">{{ $t('myuser.lastName') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.lastName" type="text" id="lastName" placeholder="" class="form-control" name="data.lastName"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.lastName')}"
                             readonly disabled
                      >
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="role" class=" form-control-label">{{ $t('myuser.role') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input :value="$t('register.roles.'+data.role)" type="text" id="role" placeholder="" class="form-control" name="data.role"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.role')}"
                             readonly disabled
                      >
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="email" class=" form-control-label">{{ $t('myuser.email') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.email" type="text" id="email" placeholder="" class="form-control" name="data.email"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.email')}"
                             readonly disabled
                      >
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="phone" class=" form-control-label">{{ $t('myuser.phone') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.phone" type="text" id="phone" placeholder="" class="form-control" name="data.phone"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.phone')}"

                      >
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="password" class=" form-control-label">{{ $t('myuser.password') }} ({{ $t('validator.min8') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.password" type="password" id="password" placeholder="" class="form-control" name="data.password"
                             v-validate="'userPassEqualMin8'" v-bind:class="{'is-invalid':errors.has('data.password')}" v-on:keyup="doValidateOnBlur">
                    </div>
                    <br><br>
                    <div class="col col-md-3"><label for="password2" class=" form-control-label">{{ $t('myuser.password2') }} ({{ $t('validator.twofieldsame') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.password2" type="password" id="password2" placeholder="" class="form-control" name="data.password2"
                             v-validate="'userPassEqualMin8'"
                             v-bind:class="{'is-invalid': errors.has('data.password2')}" v-on:keyup="doValidateOnBlur">
                      <!--v-validate="{is_not:!data.password,'required_if':({data.password}.length>0)}" v-bind:class="{'is-invalid': errors.has('data.password2')}">-->
                      <small class="form-text text-muted">{{ $t('myuser.passwordhint') }}</small>
                    </div>
                  </div>

                </form>
              </div>
              <div class="card-footer">
                <button type="button" class="btn btn-primary btn-sm" v-on:click="save()">
                  <i class="fa fa-dot-circle-o"></i> {{$t('myuser.submit')}}
                </button>
                <!--<button type="reset" class="btn btn-danger btn-sm">-->
                <!--<i class="fa fa-ban"></i> Reset-->
                <!--</button>-->
              </div>
            </div>

          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import MenuToggle from '@/components/MenuToggle.vue';
  import HelperRole from '@/helper/HelperRole';

  export default {
    name: 'UserMyProfile',
    data() {
      return {
        moduleRights: []
        , moduleRightsIds: []
        , roles: []
        , user_role: "base"
        , Helper: Helper

//        avatar: null
//        createdAt: "2020-10-29T13:53:00.235Z"
//        email: "mail@bencsikszilveszter.hu"
//        firstName: "b"
//        id: "cb09012b-8e58-4b31-b283-bb4a5c165087"
//        id_company_actual: "137f7cdd-84ae-4dd2-a6c9-08017f467d43"
//        lastName: "b"
//        phone: "1"
//        role: "ADMIN"
//        updatedAt: "2020-11-12T22:33:25.257Z"

        , data: {}
        , dataBase: {}
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 5000,
        }

        , breadcrumbstitle: 'myuser.title'
        , breadcrumbsData: [
          {
            'title': "myuser.title",
          }
        ]
        , stores: []

        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""

      };
    },
    props: {
      id: String,
    },
    watch: {

      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();
      console.log("usermyprofile");
      modul.$validator.extend('userPassEqualMin8', (val) => {
//        if (this.id) {
        return ((modul.data.password === "" && modul.data.password2 === "") || (modul.data.password.length >= 8 && modul.data.password === modul.data.password2));
//        } else {
//          if (modul.data.password && modul.data.password === modul.data.password2) {
//            return true;
//          } else {
//            return false;
//          }
//        }
      });


//      const modul = this;
//      console.log("usermyprofile mounted")
//      modul.roles = ["USER",2, 3, 4, 5, 6, 7, 8, 9, 10];
//      modul.chkRole()

    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        modul.hasRole = true;
//        if (HelperRole.hasRights(modul.state, true, true)) {
//          modul.hasRole = true;
//        }
//        if (modul.$store.state.id_company) {
//          modul.hasCompany = true;
//        }
//        if (modul.hasRole && modul.hasCompany) {
          modul.init();
//        }
      },
      init(){
        const modul = this;
        this.authMe();

      },

//
//      chkRole(){
//        const modul = this;
//        modul.hasRole = false;
//        const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
//        modul.user_role = role;
//        if (!Helper.checkRoles(modul.roles, role)) {
//          modul.hasRole = false;
////        modul.$router.push({name: "dashboard"})
//        } else {
//          modul.hasRole = true;
//        }
//
////        modul.hasRole = true;
//
//      },
      doValidateOnBlur(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
        });
      },
      authMe(){
        const modul = this;
//        let id = 0;
        try {
//          id = Number(this.id);
//          if (id > 0) {
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.authMe({}).then(function (res) {
            if (res && res.id) {
              console.log(res);
              modul.data = res;
//              modul.stores = res.stores;
            }
            modul.AlertInPage.msg = "";
          }, function (e) {
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });
//          } else {
//            modul.data = {};
//          }
        } catch (e) {

        }
      },
      emptyForNew(){
        this.data = Object.assign({}, this.dataBase);
        this.$router.push({name: "usermyprofile"})
      },
      save(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const id = modul.$store.state.user.id;
            const data = Helper.makeFilteredObjectByKeys(modul.data, ['id', "firstName", "lastName", "password", "phone"]);
            Api.saveMyUser({id: id, data: data}).then(function (res) {
              if (res && res.result) {
                if (res && res.data.id) {
                  modul.data.id = res.data.id;
                }
                modul.AlertInPage.msg = "form.save_succes";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              } else {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.save_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
          }
        });
      },


      keymonitorNext(event){
        const modul = this;
        if (event.key === "Enter") {
          document.querySelector('[type="password"]').focus();
        }
      },
      keymonitor(event){
        const modul = this;
        if (event.key === "Enter") {
          modul.register();
        }
      },
      doValidateOnBlur(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
        });
      },


    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      MenuToggle
    },
  };
</script>








